import React from 'react';
import { IconFill, IconOutline } from '@ant-design/icons-react-native';

const getTabBarIcon = (
    iconName: string | undefined,
    focused: boolean,
    color: string,
    size: number,
) => {
    if (focused) {
        return <IconFill name={iconName as any} size={size} color={color} />;
    }
    return <IconOutline name={iconName as any} size={size} color={color} />;
};

export default getTabBarIcon;
